import * as React from "react";
import uhaulStore from "../CustomRedux/UhaulStore";
import { updateTeamsView } from "./Actions/SupervisorStatisticsActions";
import {containsInitialResponse, getLocalTkn, initialResponseBody, removeClosedData} from "./Actions/CommonActions";
import {SyncClient} from "twilio-sync";
import { Manager } from "@twilio/flex-ui";

export class InitialAgentMessage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelSid: "",
            value: "",
            hasInitialMessage: false,
            displayBargeButton: true,
            displayTextArea: false,
            properties: props,
            bargedChats: [],
            syncClient: new SyncClient(getLocalTkn() || ""),
            hasBeenBarged: null
        };
        this.serviceBaseUrl = uhaulStore.getState().UhaulReducer.currentUser.serviceBaseUrl;

        if (uhaulStore.getState().UhaulReducer.currentTaskContext == null || uhaulStore.getState().UhaulReducer.currentTaskContext.task == null) {
            uhaulStore.dispatch(updateTeamsView(this.props));
        }
    }

    state = this.getCurrentStateFromStore();

    getCurrentStateFromStore() {
        return {
            config: uhaulStore.getState().FlexReducer.config,
            supervisorStatistics: uhaulStore.getState().UhaulReducer.supervisorStatistics,
            taskQueueCategories: uhaulStore.getState().UhaulReducer.taskQueueCategories,
            currentSelectedCategory: uhaulStore.getState().UhaulReducer.currentSelectedCategory,
            teamsView: uhaulStore.getState().UhaulReducer.teamsView
        }
    }

    updateStateFromStore = () => {
        const currentState = this.getCurrentStateFromStore();

        if (this.state !== currentState) {
            this.setState(currentState);
        }
    }

    componentWillUnmount() {
        removeClosedData();
        this.unsubscribeStore();
    }

    /*1/30/19 - Task #475881: Live Chat - Auto Response intermittant on Agent-to-agent chat*/
    componentDidMount()
    {
        this.unsubscribeStore = uhaulStore.subscribe(this.updateStateFromStore);

        //send message if the canvas has done loading and there are no messages from the agent yet.
        if (this.state.hasInitialMessage || !this.props || !this.props.channelSid || !this.props.channel || this.props.channel.isLoadingMessages || !this.props.channel.messages) {
            return;
        }

        const currentTask = uhaulStore.getState().UhaulReducer.currentTaskContext

        const isMonitoringChat = () => this.props.disabledReason !== "You are not a participant of this chat"
        const alreadyHasAutoResponse = () => this.props.channel.messages.filter(x => x.source.body && containsInitialResponse(x.source.body).length > 0)
        
        const taskIsWrapping = (task) => (task.taskStatus && task.taskStatus === "wrapping")
                                         && (task.status && task.status === "wrapping")
        const isWrapping = () => currentTask && (currentTask.attributes?.MonitoredBy || taskIsWrapping(currentTask))

        if (!isMonitoringChat()
            && !alreadyHasAutoResponse()
            && !isWrapping()
            )
        {
            //And if the user has not sent anything yet
            if (this.props.channel.messages.filter(x => x.isFromMe).length <= 0 
                && (!currentTask.attributes.isBargedOn)
                && this.props.channel?.source?.attributes?.pre_engagement_data
                && currentTask?.taskChannelUniqueName === "sms"
                && !isNaN(this.props.channel.source.attributes.pre_engagement_data.phoneNumber.trim()))
            {
                var foundCustNumber = this.props.channel.source.attributes.pre_engagement_data.phoneNumber.trim();
                var textInNumber = currentTask.attributes.friendlyName.trim().replace(/[^0-9]/g, '')
                textInNumber = textInNumber.substring(textInNumber.length - 10)

                const useTextInNumber = currentTask.attributes?.phoneNumber && textInNumber !== "" && textInNumber !== currentTask.attributes.phoneNumber
                const phoneNumber = useTextInNumber ? textInNumber.trim().length === 10 ? '+1' + textInNumber.trim(): textInNumber.trim() : foundCustNumber
                
                fetch(this.serviceBaseUrl + 'send-text-msg',
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    method: "POST",
                    body: new URLSearchParams({
                        Token: Manager.getInstance().user.token,
                        customerPhoneNumber: phoneNumber,
                        messageBody: initialResponseBody(currentTask),
                    })
                })
                .catch((_) => {});
            }
        }

        this.setState({ hasInitialMessage: true });
    }

    render() {
        return null;
    }
 }
